import { FC } from 'react';
import { Target } from 'lucide-react';

interface Props {
  classCount: number;
}

export const ActiveFocusBanner: FC<Props> = ({ classCount }) => (
  <div
    className="tw-flex tw-w-[285px] tw-items-center tw-gap-2 tw-rounded-xl tw-border-2 tw-border-solid tw-border-[#C2C9FE] tw-bg-[#EEF0FF] tw-px-3 tw-py-2"
    data-testid="active-focus-banner"
  >
    <span className="tw-inline-flex tw-shrink-0 tw-text-[#5776FC]">
      <Target size={16} aria-hidden />
    </span>
    <span className="tw-whitespace-nowrap tw-text-base tw-font-bold tw-leading-5 tw-text-neutral-950">
      Active focus
    </span>
    <span className="tw-w-0.5 tw-shrink-0 tw-self-stretch tw-rounded-[80px] tw-bg-indigo-100" aria-hidden />
    <span className="tw-whitespace-nowrap tw-rounded-md tw-border-2 tw-border-solid tw-border-indigo-100 tw-bg-neutral-0 tw-px-2.5 tw-py-0.5 tw-text-xs tw-font-bold tw-leading-4 tw-text-neutral-950">
      {`Shared · ${classCount} class${classCount === 1 ? '' : 'es'}`}
    </span>
  </div>
);
